import supported from './isSupoortObjectDefineProperty';
import { isObject, isEmpty } from './util';

export default function parsePath(path) {
    let reg = /^[[\w]+|[\w+\[\d+\]]][\.\w]*$/;
    if (!reg.test(path)) {
        return function(){
            return;
        };
    }
    let data_stack = path.split('.');
    return function (obj) {
        let can_reach = true;
        let reach_val = obj;
        for(let key of data_stack) {
            let array_key_reg = /^([\w]+)\[(\d+)\]$/; 
            // let array_key_reg = /^([\w]+)([\[\d+\]]+)$/; 
            if (array_key_reg.test(key)) {
                let match_result = key.match(array_key_reg);
                if (match_result && match_result.length >=3) {
                    let reach_key = match_result[1];
                    let reach_index = match_result[2];
                    if (isObject(reach_val) && !isEmpty(reach_val) && reach_val.hasOwnProperty(reach_key)) {
                        if (reach_val[reach_key] instanceof Array) {
                            if (supported) {
                                reach_val = reach_val[reach_key][reach_index];
                            } else if (typeof reach_val.__vm__get === 'function'){
                                reach_val = reach_val.__vm__get(reach_key);
                                reach_val = reach_val[reach_index];
                            } else {
                                reach_val = reach_val[reach_index][reach_index];
                            }
                        }
                    } else {
                        can_reach = false;
                        break; 
                    }
                }
            } else if(isObject(reach_val) && !isEmpty(reach_val) && reach_val.hasOwnProperty(key)) {
                if (supported) {
                    reach_val = reach_val[key]
                } else if (typeof reach_val.__vm__get === 'function'){
                    reach_val = reach_val.__vm__get(key);
                } else {
                    reach_val = reach_val[key]
                }
            } else {
                can_reach = false;
                break;
            }
        }
        if (can_reach) {
            return reach_val;
        }
        return;
    }
}
